import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { Carrier } from '../../types';

export interface GetCarrierListRequestParams {
  customerKey: number;
}

export const getCarrierListAPI = (params: GetCarrierListRequestParams) => {
  return axiosInstance.request({
    url: `${API.POV}/GetCarrier`,
    method: 'get',
    params,
  });
};

export type CarrierListResponse = Carrier[];

export const fetchCarrierList = async (params: GetCarrierListRequestParams): Promise<CarrierListResponse> => {
  const response: AxiosResponse<CarrierListResponse> = await getCarrierListAPI(params);
  return response.data;
};
